import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

const TdValue = ({ data = {}, trendEvaluator = defaultTrendEvaluator }) => {
  const { t } = useTranslation();
  const { score, trend, prevScore } = data;
  const trendFactor = trendEvaluator(trend, score);

  const tooltipTitle = isValidNumber(prevScore) ? `${t('previous')}: ${String(prevScore)}` : undefined;

  return (
    <div className='td cell-value'>
      <span className='cell-value_title'>{score}</span>
      {isValidNumber(trend) && (
        <StyledTooltip title={tooltipTitle} placement='top' disableInteractive arrow>
          <span
            className={clsx(
              'cell-value_offset',
              trendFactor === 1 && 'cell-value_offset_increase',
              trendFactor === -1 && 'cell-value_offset_decrease',
              isValidNumber(prevScore) && 'cell-value_offset--tooltiped',
            )}>
            {trend}
            <Icon icon={ICONS.ArrowUp} disableCommonStyles />
          </span>
        </StyledTooltip>
      )}
    </div>
  );
};

export default TdValue;

function defaultTrendEvaluator(trend) {
  return trend < 0 ? -1 : 1;
}

function isValidNumber(value) {
  return !isNaN(+value);
}

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '10px',
    left: '-8px',
  },
});
